module.exports = __webpack_public_path__ + "static/media/arklow.4bd04603.jpg";